enum SubAccountStatusEnum {
  Invited = 0,
  Active = 1,
  Deactivated = 2,
  InviteExpired = 3,
}

export default SubAccountStatusEnum;
